export const AcademictimetableActions = {
  GET_ACADEMIC_TIMETABLE: "GET_ACADEMIC_TIMETABLE",
  SET_ACADEMIC_TIMETABLE: "SET_ACADEMIC_TIMETABLE",
};
